import { colors, fontSize, fontWeight, shorthandHelper, spacing } from '@offerzen/pinata'
import { css } from '@emotion/css'

const styles = {
  noResultsContainer: css({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 1022,
    width: '100%',
    backgroundColor: colors.white,
    padding: '24px',
    lineHeight: '140%',
    textAlign: 'center',
    margin: 'auto',
    zIndex: 1,

    strong: {
      fontWeight: fontWeight.bold,
      fontSize: fontSize.medium,
      color: '#131F4A',
      maxWidth: 550,
      margin: 'auto',
      padding: shorthandHelper([0, spacing.large]),
    },
  }),

  content: css({
    fontWeight: fontWeight.regular,
    fontSize: fontSize.default,
    color: colors.scorpion,
    maxWidth: 550,
    margin: '8px auto',
    padding: shorthandHelper([0, spacing.large]),
  }),
}

export default styles
